// -----------------------------------------------------------------------------
// Company Telephone Numbers
// -----------------------------------------------------------------------------

// TelValue expects a string in the format "(XXX) XXX-XXXX", e.g., "(888) 212-8843"
type TelValue = `(${number}) ${number}-${number}`;

export const telOnlineSupport: TelValue = "(888) 212-8843";

export const telCashManagement: TelValue = "(888) 792-7526";

export const telCashManagementOutsideUsa: TelValue = "(610) 382-8227";

// -----------------------------------------------------------------------------
// Company Hours
// -----------------------------------------------------------------------------

const ndash = "\u2013";

export const hoursOnlineSupport = `Monday ${ndash} Friday, 7:00 a.m. to 6:00 p.m. (CT)`;

export const hoursAddressChanges = `Monday ${ndash} Friday, 8:00 a.m. to 5:00 p.m. (CST)`;

export const hoursCashManagement = `Monday ${ndash} Friday, 8:30 a.m. to 5:00 p.m. (CT)`;
